<template>
  <div v-click-outside="close" class="dropdown text-center cursor-pointer">
    <div class="title z-10" @click="!extended ? open() : close()">
      <div
        class="bg-classen__secondary title-text border-shadow border-classen__secondary bg-white grid grid-cols-11">
        <div class="col-span-10 whitespace-nowrap pl-5 text-left flex flex-wrap">
          <p v-if="selectedRegions.length===0" class="placeholder">Add region(s)...</p>
          <div v-if="selectedRegions.length>0" v-for="(region, index) in selectedRegions"
               @click="region.selected=false"
               :id="`region-${index}`"
               class="selected_regions text-sm p-1 rounded-20 my-1 mr-2">
            <span class="pr-2.5">{{ region.name }}</span>
            <span><i class="fas fa-times text-m py-0"></i></span>
          </div>
        </div>
        <p class="self-center justify-self-end pr-5">
          <span v-show="!extended"><svg class="fas fa-angle-down"></svg></span>
          <span v-show="extended"><svg class="fas fa-angle-up"></svg></span>
        </p>
      </div>
    </div>
    <div class="dropdown-content" v-if="extended">
      <div class="grid h-full px-2">
        <input v-model="searchInput" type="text" :placeholder="getTranslation('search')"
               class="border-shadow rounded-20 search px-1 my-2 w-1/3">
        <div class="text-left body grid overflow-y-auto" style="max-height: 230px;">
          <div v-for="region in filteredRegions" @click="region.selected = !region.selected"
               class="cursor-pointer hover:bg-classen__secondary flex justify-between py-0.5"
               :class="{'bg-classen__secondary':(region.selected)}">
            <p :class="{'region_name_selected':region.selected}">{{ region.name }}</p>
            <span v-if="region.selected" class="selected pr-7">Selected</span>
          </div>
        </div>

        <form v-on:submit.prevent="createNewRegion()" v-if="canCreateNewRegion"
              class="text-left z-10 border-t-2 py-1 border-classen__secondary text-sm">
          <div v-if="regionNameExists" class="text-xs mb-1 text-red-600">
            *Region exists
          </div>
          <div class="flex">
            <button v-if="!regionNameExists" type="submit" for="create" class="pr-1">
              <i class="fas fa-plus-circle"></i>
            </button>
            <button v-else type="submit" for="create" class="text-red-600 pr-1">
              <i class="fas fa-times-circle"></i>
            </button>
            <input id="create" type="text" v-model="newRegion" class="text-black"
                   :placeholder="'Create new region'" required autocomplete="off"/>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import ClickOutside from 'vue-click-outside'
import EventBus from "../../../services/EventBus";
import getTranslation from "../../../mixins/getTranslation";
import getPermissions from "../../../mixins/getPermissions";
import Button from "../../Button";

export default {
  name: "AddUsersRegionDropdown",
  components: {Button},
  props: {
    selectedRegions: {required: true},
    canCreateNewRegion: {required: false, default: false},
  },

  mixins: [getTranslation, getPermissions],

  data() {
    return {
      extended: false,
      regionsCopy: [],
      allSelected: false,
      regionSelected: [],
      searchInput: '',
      newRegion: '',
    }
  },

  watch: {
    regionsSelected() {
      this.$emit('update:selectedRegions', this.regionsSelected)
    }
  },

  created() {
    this.regionsCopy = this.regions;

    EventBus.listen('close-dropdowns', this.close)
  },

  destroyed() {
    this.regions.forEach((region) => {
      region.selected = false
    })
    EventBus.destroy('close-dropdowns', this.close)
  },

  computed: {
    activeUser() {
      return this.$dashboardStore.getters.getActiveUser();
    },

    regionNameExists() {
      return this.regions.find((region) => {
        return region.name.toLowerCase() === this.newRegion.toLowerCase();
      }) !== undefined;
    },

    regions() {
      let regions = this.$dashboardStore.getters.getRegions;
      if (this.activeUserHasRole(this.ROLES.REGIONAL_ADMIN)) {
        regions = regions.filter((region) => this.activeUser.regions.includes(region.id));
      }
      return regions;
    },

    regionsSelected() {
      return this.regions.filter((region) => {
        return region.selected && region.selected === true
      }).sort((a, b) => a.name.localeCompare(b.name));
    },

    filteredRegions() {
      let filteredRegions = this.regions.filter((region) => {
        return region.name.toLowerCase().includes(this.searchInput.toLowerCase());
      }).sort((a, b) => a.name.localeCompare(b.name));

      filteredRegions.forEach((region) => {
        let found = false;

        this.selectedRegions.forEach((selectedRegion) => {
          if (selectedRegion.id === region.id) {
            found = true;
          }
        })

        if (found) {
          region.selected = true;
        }
      })

      return filteredRegions;
    },
  },

  methods: {
    createNewRegion() {
      let existingRegions = this.regions.filter((e) => {
        return e.name.toLowerCase() === this.newRegion.toLowerCase();
      });

      if (existingRegions.length === 0) {
        this.$dashboardStore.dispatch('addRegion', {name: this.newRegion})
          .then((res) => {
            this.$dashboardStore.commit('ADD_REGION', res.data);
          }).catch((error) => {
          console.warn('something went wrong adding region', error);
        });
      }

      this.newRegion = '';
    },

    open() {
      EventBus.fire('close-dropdowns')
      this.extended = true
    },

    close() {
      this.extended = false
    }
  },

  directives: {
    ClickOutside
  }
}
</script>

<style scoped>
* {
  user-select: none;
}

.title {
  border-radius: 20px 20px 0 0;
}

.displayed > .title {
  border: 1px solid #EAEBEC;
  border-bottom: none;
}

.dropdown {
  position: relative;
  min-width: 250px;
  display: inline-block;
}

.dropdown-content {
  position: absolute;
  background-color: #FFFFFF;
  width: 100%;
  z-index: 1;
  border-radius: 0 0 20px 0;
  border: 1px solid #EAEBEC;
  border-top: none;
}

.region_name_selected {
  color: #8E9193;
}

.selected, .placeholder {
  color: #C0C0C0;
}

.selected_regions {
  background-color: #C7C8C9;
}

.body:last-child {
  border: none;
}

.search {
  height: 30px;
  line-height: 30px;
}
</style>
